angular.module('NiacsProjectApp.controllers-general', [
])
.controller('NotificationCtrl', ['$scope','NotificationService',
  function($scope,NotificationService){
    $scope.alerts = NotificationService.getAlerts();
    $scope.closeAlert = NotificationService.closeAlert;
    var $ = ($||jQuery);
    if (navigator.appName == 'Microsoft Internet Explorer' ||  !!(navigator.userAgent.match(/Trident/) ||
        navigator.userAgent.match(/rv:11/)) || (typeof($.browser) !== 'undefined' && $.browser.msie == 1)) {
        NotificationService.addError('<p>The Adaptation Workbook may not function properly in Internet Explorer.\n\nIf you experience any difficulty using the site, please open it in another browser such as Chrome (recommended) or Firefox</p>');
    }
}])
.controller('ConfirmDialogCtrl',['$scope','$uibModalInstance','onOk',function($scope,$uibModalInstance,onOk){
    $scope.ok = function() {
        onOk();
        $uibModalInstance.close('ok');
    };
    $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };
}]);
